import { render } from "./pro-spec.vue?vue&type=template&id=09a56a0a&scoped=true"
import script from "./pro-spec.vue?vue&type=script&lang=js"
export * from "./pro-spec.vue?vue&type=script&lang=js"

import "./pro-spec.vue?vue&type=style&index=0&id=09a56a0a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-09a56a0a"

export default script